var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "30px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索母液...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchMLCost
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "200px",
      "margin-right": "30px"
    },
    attrs: {
      "placeholder": "筛选工厂",
      "label-in-value": "",
      "multiple": ""
    },
    on: {
      "on-clear": _vm.initList,
      "on-change": _vm.choseFactory
    },
    model: {
      value: _vm.selectedFactory,
      callback: function ($$v) {
        _vm.selectedFactory = $$v;
      },
      expression: "selectedFactory"
    }
  }, _vm._l(_vm.factoryList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c('Select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "筛选标签",
      "label-in-value": "",
      "multiple": ""
    },
    on: {
      "on-clear": _vm.initList,
      "on-change": _vm.choseTags
    },
    model: {
      value: _vm.selectedTags,
      callback: function ($$v) {
        _vm.selectedTags = $$v;
      },
      expression: "selectedTags"
    }
  }, _vm._l(_vm.tagList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('div', {
    staticClass: "semi-contrast-wrap",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/home/SemiContrast');
      }
    }
  }, [_c('div', {
    staticClass: "semi-contras"
  }, [_vm._v("母液对比")])]), _c('div', {
    staticClass: "page-wrap"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    attrs: {
      "total": _vm.totalRows,
      "page-size": 50,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadCaclMLCost
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.caclAllMLCost();
      }
    }
  }, [_vm._v("计算全部成本")])], 1)])]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.semiItemCostList,
      "height": _vm.tableHeight
    }
  })], 1), _c('CaclMLDetailDrawer', {
    ref: "CaclMLDetailDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }